import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import data from "../assets/fake-data/data-collection";
import { googleLoginRequest, loginApi } from "../services/auth/loginApi";
import { toast, ToastContainer } from "react-toastify";
import { GoogleLogin } from "@react-oauth/google";
import { useTranslation } from "react-i18next";
import Loader from "../components/loader/loader";
import { Spin } from "antd";
import TwoFactorVerification from "./TwoFactorVerification";

const ClientId =
  process.env.GOOGLE_CLIENT_ID ||
  "468771891072-uk3qjcaa0n1sgdg0q4cnu0jch7hjjf8j.apps.googleusercontent.com";
const ClientSecret =
  process.env.GOOGLE_CLIENT_SECRET || "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";

const baseUrl = "https://api.masterfut.com";

function Login(props) {
  const { t } = useTranslation();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showTwoFactor, setShowTwoFactor] = useState(false);
  const [emailForVerification, setEmailForVerification] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingSignIn, setIsLoadingSignIn] = useState(false);

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem("authToken");
      if (token) {
        navigate("/", { replace: true });
      }
    };

    const interval = setInterval(checkToken, 1000); // runs every 1 second

    return () => clearInterval(interval); // cleanup on component unmount
  }, [navigate]);

  useEffect(() => {
    const handleLoad = () => {
      const token = localStorage.getItem("authToken");

      if (token) {
        navigate("/"); // or navigate('/dashboard');
      } else {
        setIsLoading(false);
      }
    };

    // Check if the page has already loaded
    if (document.readyState === "complete") {
      setIsLoading(false);
    } else {
      window.addEventListener("load", handleLoad);
    }

    // Cleanup
    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  const handleSubmit = async () => {
    setIsLoadingSignIn(true);
    try {
      const result = await loginApi(login, password);

      // Check if 2FA is required
      if (result.requiresTwoFactor) {
        setEmailForVerification(result.email);
        setShowTwoFactor(true);
        toast.info(result.message);
      } else {
        // Normal login success
        if (result.roles[0].name == "admin" || result.roles[0].name == "superadmin") {
          window.location.href = "/dashboard";
        } else {
          window.location.href = "/";
        }
      }
    } catch (error) {
      toast.error(t("login field"));
    } finally {
      setIsLoadingSignIn(false);
    }
  };

  const handleVerificationSuccess = (user) => {
    if (user.roles[0].name == "admin" || user.roles[0].name == "superadmin") {
      window.location.href = "/dashboard";
    } else {
      window.location.href = "/";
    }
  };

  const handleBackToLogin = () => {
    setShowTwoFactor(false);
    setEmailForVerification("");
  };

  const handleGoogleLogin = (response) => {
    googleLoginRequest(response)
      .then((res) => (window.location.href = "/"))
      .catch((error) => toast.error(t("Google login failed")));
  };



  return (
    <>
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
          <Loader />
        </div>
      ) : (
        <>
          <div>
            <section className="bg-sign-in">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <div className="content-left vertical-carousel">
                      <div className="content-slide">
                        <Swiper
                          className="collection-1"
                          direction={"vertical"}
                          spaceBetween={30}
                          slidesPerView={3}
                          loop={true}
                          modules={[Autoplay]}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                          }}
                        >
                          {data.slice(0, 7).map((idx) => (
                            <SwiperSlide key={idx.id}>
                              <div className="slider-item">
                                <div className="tf-product ">
                                  <div className="image">
                                    {/* <img src={idx.img} alt="Binabox" /> */}
                                    <div
                                      style={{
                                        color: "white",
                                        width: "251px",
                                        height: "251px",
                                      }}
                                      className="d-flex justify-content-center align-items-center m-0 p-0"
                                    >
                                      <svg
                                        style={{
                                          filter:
                                            "drop-shadow(0 0 5px rgba(255, 132, 0, 0.7))",
                                        }}
                                        className="m-0 p-0"
                                        fill="#fbb360"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="140"
                                        height="140"
                                        viewBox="0 0 24 24"
                                      >
                                        <path d="M9,5H2V19H5V8H8A1,1,0,0,1,9,9v1a1,1,0,0,1-1,1H6v3H9a3,3,0,0,0,3-3V8A3,3,0,0,0,9,5Z"></path>
                                        <path d="M17,8h5V5H16a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3h6V16H17a1,1,0,0,1-1-1V9A1,1,0,0,1,17,8Z"></path>
                                      </svg>{" "}
                                    </div>
                                  </div>
                                  <h6 className="name">
                                    <Link to="/item-details">PC</Link>
                                  </h6>
                                </div>
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                        <Swiper
                          className="collection-1"
                          direction={"vertical"}
                          spaceBetween={30}
                          slidesPerView={3}
                          // breakpoints={{
                          //     0: {
                          //         slidesPerView: 1,
                          //         },
                          //     500: {
                          //         slidesPerView: 2,
                          //         },
                          //     768: {
                          //         slidesPerView: 3,
                          //     },
                          //     991: {
                          //         slidesPerView: 4,
                          //     },
                          // }}

                          loop={true}
                          modules={[Autoplay]}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                          }}
                        >
                          {data.slice(3, 9).map((idx) => (
                            <SwiperSlide key={idx.id}>
                              <div className="slider-item ">
                                <div className="tf-product">
                                  <div className="image">
                                    {/* <img src={idx.img} alt="Binabox" /> */}
                                    <div
                                      style={{
                                        color: "white",
                                        width: "251px",
                                        height: "251px",
                                      }}
                                      className="d-flex justify-content-center align-items-center m-0 p-0"
                                    >
                                      <svg
                                        style={{
                                          filter:
                                            "drop-shadow(0 0 5px rgba(130, 181, 249, 0.83))",
                                        }}
                                        className="m-0 p-0"
                                        fill="#8abbff"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="140"
                                        height="140"
                                      >
                                        <path d="M 9 3.1875 L 9 19.8125 L 12.59375 20.90625 L 12.59375 7 C 12.59375 6.601563 12.613281 6.386719 12.8125 6.1875 C 12.914063 5.988281 13.113281 5.992188 13.3125 6.09375 C 13.8125 6.292969 14.09375 6.699219 14.09375 7.5 L 14.09375 13 C 15.292969 13.601563 16.292969 13.601563 17.09375 13 C 17.894531 12.398438 18.3125 11.5 18.3125 10 C 18.3125 8.398438 18.011719 7.394531 17.3125 6.59375 C 16.710938 5.792969 15.601563 5.09375 14 4.59375 C 12 3.992188 10.300781 3.488281 9 3.1875 Z M 8 13.59375 L 3.40625 15.1875 L 2.6875 15.5 C 1.585938 16 1 16.5 1 17 C 1.101563 17.601563 1.3125 18.40625 2.8125 18.90625 C 4.210938 19.40625 5.292969 19.613281 8.09375 18.8125 L 8.09375 17 C 5.394531 17.898438 4.992188 17.792969 4.59375 17.59375 C 4.195313 17.394531 4.210938 17.195313 4.3125 17.09375 C 4.613281 16.894531 5.6875 16.5 5.6875 16.5 L 8 15.6875 Z M 18.1875 14.375 C 17.863281 14.363281 17.511719 14.382813 17.1875 14.40625 C 16.085938 14.40625 15.105469 14.605469 13.90625 14.90625 L 13.90625 17 L 16.09375 16.1875 L 17.3125 15.8125 C 17.3125 15.8125 17.792969 15.695313 18.09375 15.59375 C 18.59375 15.492188 19.1875 15.6875 19.1875 15.6875 C 19.488281 15.6875 19.6875 15.800781 19.6875 16 C 19.789063 16.199219 19.59375 16.300781 19.09375 16.5 L 18 16.90625 L 14 18.40625 L 14 20.5 L 15.8125 19.90625 L 20.8125 18.09375 L 21.40625 17.8125 C 22.605469 17.414063 23.101563 16.914063 23 16.3125 C 23 15.710938 22.292969 15.304688 21.09375 14.90625 C 20.117188 14.605469 19.164063 14.40625 18.1875 14.375 Z"></path>
                                      </svg>
                                    </div>
                                  </div>
                                  <h6 className="name">
                                    <Link to="/item-details">PlayStation</Link>
                                  </h6>
                                </div>
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                        <Swiper
                          className="collection-1"
                          direction={"vertical"}
                          spaceBetween={30}
                          slidesPerView={3}
                          loop={true}
                          modules={[Autoplay]}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                          }}
                        >
                          {data.slice(7, 13).map((idx) => (
                            <SwiperSlide key={idx.id}>
                              <div className="slider-item">
                                <div className="tf-product ">
                                  <div className="image">
                                    <div
                                      style={{
                                        color: "white",
                                        width: "251px",
                                        height: "251px",
                                      }}
                                      className="d-flex justify-content-center align-items-center m-0 p-0"
                                    >
                                      <svg
                                        style={{
                                          filter:
                                            "drop-shadow(0 0 5px rgba(0, 255, 21, 0.67))",
                                        }}
                                        className="m-0 p-0"
                                        fill="#62d96b"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="140"
                                        height="140"
                                      >
                                        <path d="M 12 2 C 10.375 2 8.375 2.503906 6.875 3.40625 C 6.816406 3.441406 6.707031 3.535156 6.59375 3.625 C 8.234375 2.6875 11.917969 5.621094 12 5.6875 C 12.082031 5.621094 15.765625 2.691406 17.40625 3.625 C 17.292969 3.535156 17.183594 3.441406 17.125 3.40625 C 15.625 2.503906 13.878906 2 12 2 Z M 5.6875 4.59375 C 5.351563 4.648438 4.980469 4.871094 4.65625 5.21875 C 3.003906 7.003906 2 9.378906 2 12 C 2 14.589844 2.976563 16.941406 4.59375 18.71875 C 4.0625 16.152344 4.554688 14.351563 6 12 C 7.449219 9.648438 10 7 10 7 C 7.898438 5.015625 6.410156 4.664063 6.03125 4.59375 C 5.929688 4.574219 5.800781 4.574219 5.6875 4.59375 Z M 4.59375 18.71875 C 6.421875 20.730469 9.078125 22 12 22 C 14.929688 22 17.578125 20.726563 19.40625 18.71875 C 19.402344 18.691406 19.191406 17.394531 17.84375 15.53125 C 16.792969 14.078125 13.667969 10.582031 12 9 C 10.332031 10.582031 7.207031 14.046875 6.15625 15.5 C 4.808594 17.359375 4.597656 18.6875 4.59375 18.71875 Z M 19.40625 18.71875 C 21.019531 16.941406 22 14.589844 22 12 C 22 9.378906 20.996094 7.003906 19.34375 5.21875 C 18.914063 4.753906 18.367188 4.519531 17.96875 4.59375 C 17.589844 4.664063 16.101563 5.015625 14 7 C 14 7 16.550781 9.648438 18 12 C 19.445313 14.351563 19.9375 16.152344 19.40625 18.71875 Z"></path>
                                      </svg>
                                    </div>
                                  </div>
                                  <h6 className="name">
                                    <Link to="/item-details">Xbox</Link>
                                  </h6>
                                </div>
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {showTwoFactor ? (
                      <TwoFactorVerification
                        email={emailForVerification}
                        type="login"
                        onVerificationSuccess={handleVerificationSuccess}
                        onBack={handleBackToLogin}
                      />
                    ) : (
                      <div className="sign-in-form">
                        <h2>{t("SIGN IN")}</h2>
                        <p>{t("Welcome back! Please enter your details")}</p>
                        <form action="#" id="contactform">
                          <fieldset>
                            <input
                              value={login}
                              onChange={(e) => setLogin(e.target.value)}
                              id="name"
                              name="name"
                              tabIndex="1"
                              aria-required="true"
                              required=""
                              type="text"
                              placeholder={t("Username or Email")}
                            />
                          </fieldset>
                          <fieldset>
                            <input
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              id="showpassword"
                              name="password"
                              tabIndex="2"
                              aria-required="true"
                              type="password"
                              placeholder={t("Password")}
                              required=""
                            />
                          </fieldset>
                          <div className="forgot-pass-wrap">
                            <Link to="/forgot-password">{t("Forgot your password?")}</Link>
                          </div>
                          <button
                            onClick={handleSubmit}
                            className="tf-button submit"
                            type="button"
                            disabled={isLoadingSignIn}
                          >
                            {isLoadingSignIn ? <Spin /> : t("SIGN IN")}
                          </button>
                        </form>
                        <div className="choose-sign">
                          {t("Do you have account?")}{" "}
                          <Link to="/signup">{t("Sign up")}</Link>
                        </div>

                        <div className="or">
                          <span>{t("or")}</span>
                        </div>

                        <div className="d-flex justify-content-center">
                          <GoogleLogin
                            onSuccess={handleGoogleLogin}
                            onError={() => toast.error(t("Google login failed"))}
                            text={t("Sign in with Google")}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
            <ToastContainer draggable />
          </div>
        </>
      )}
    </>
  );
}

export default Login;
